<template>
    <div class="template-item" @click="useTemplate">
        <!-- {{ template.previewUrl }} -->
        <img v-if="!isSvgPreview"
            :src="template.previewUrl + '?x-oss-process=image/resize,w_800/quality,q_80/format,webp'" alt=""
            class="template-image">
        <img v-else :src="template.previewUrl" alt="" class="template-image svg-preview">
    </div>
</template>

<script lang="ts" setup>
import { ref, reactive, computed } from 'vue';
import { useSdkStore } from '@/stores/sdk'

const sdkStore = useSdkStore()

const desginsdk = sdkStore.getSdk()
const props = defineProps<{
    template?: any,
}>()

// 计算属性：判断是否为SVG预览
const isSvgPreview = computed(() => {
    if (!props.template?.previewUrl) return false;
    const url = props.template.previewUrl.toLowerCase();
    return url.endsWith('.svg') || url.includes('.svg?') || url.includes('format=svg');
});
const useTemplate = async () => {
    let templates = props.template.fileUrl.split(',')
    for (let i = 0; i < templates.length; i++) {
        await useMaterialTemplate(templates[i])
    }
}

const useMaterialTemplate = async (item) => {
    const fileSuffix = item.split('.').pop()
    if (['jpg', 'jpeg', 'png', 'webp'].includes(fileSuffix)) {
        desginsdk.addElement.createImageElement(item)
        return
    }
    desginsdk.designOpt.requireFile(item)

}

</script>
<style lang="scss" scoped>
.template-item {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    overflow: hidden;
    position: relative;
    aspect-ratio: 1;
    width: 100%;
    height: 80px;
}

.template-item:hover {
    .template-image {
        transform: scale(1.1);
        transition: all 0.3s ease;
    }
}

.template-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    transition: all 0.3s ease;
}

.svg-preview {
    /* SVG特定样式 */
    background-color: #f8f9fa;
    padding: 8px;
    box-sizing: border-box;
}

.bigimg {
    width: 100%;
    height: 250px;
}
</style>
